import styled from 'styled-components';

export const Container = styled.div`
  padding: 1rem;
`;

export const ReferenceBlock = styled.div`
  background: #f4f6f9;
  border: 1px solid #e1e5ec;
  border-left: 3px solid var(--primary-color);
  border-radius: 4px;
  padding: 16px 18px;
`;

export const ReferenceText = styled.div`
  text-align: justify;
  text-justify: inter-word;
  hyphens: auto;
  overflow-wrap: anywhere;
  line-height: 1.75;
  color: #2f2f2f;

  em {
    font-style: italic;
  }
`;

export const Legend = styled.p`
  margin: 12px 0 0;
  color: #00274f;
  font-weight: bold;
  text-align: left;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
`;

export const CopyButton = styled.button`
  display: inline-flex;
  align-items: center;
  background: #fff;
  border: 1px solid var(--primary-color);
  border-radius: 4px;
  color: var(--primary-color);
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  padding: 9px 16px;
  outline: none;
  transition: background 0.2s, color 0.2s;

  i {
    margin-right: 8px;
    font-size: 16px;
  }

  &:hover,
  &:focus {
    background: var(--primary-color);
    color: #fff;
  }
`;

export const Loading = styled.div`
  display: flex;
  justify-content: center;
  padding: 2rem;
  color: var(--primary-color);
  font-size: 3rem;
`;
